import React from 'react';
import './Hero.css';
import AnchorLink from 'react-anchor-link-smooth-scroll';

const Hero = () => {
  return (
    <div id="home" className="hero">
      <h1>
        <span>Hi, I am Wojciech Jurasz!</span>
      </h1>
      <p>Software developer and Cybersecurity student in Rzeszów, Poland.</p>
      <p>
        I work in <span>.NET</span>, <span>React</span>, <span>Python</span> and <span>Java</span>.
      </p>

      <div className="hero-action">
        <div className="hero-connect">
          <AnchorLink className="anchor-link" offset={50} href="#contact">
            Contact Me
          </AnchorLink>
        </div>
        <a
          href={`${process.env.PUBLIC_URL}/Wojciech_Jurasz_Resume.pdf`}
          target="_blank"
          rel="noopener noreferrer"
          className="hero-resume"
        >
          My Resume
        </a>
      </div>
    </div>
  );
};

export default Hero;
